import logo from './logo.svg';
import {ThemeProvider} from '@material-ui/styles';
import {BrowserRouter as Router} from 'react-router-dom';
import {Provider as ReduxProvider} from 'react-redux';
import {store, persistor} from './store';
import {PersistGate} from 'redux-persist/integration/react';
import theme from './theme';
import './App.css';
import {ScrollToTop} from './utils/scroll';
import routes from './routes';

function App() {
  return (
      <ThemeProvider theme={theme}>
        <PersistGate loading={null} persistor={persistor}>
          <ReduxProvider store={store}>
            <Router>
              <ScrollToTop/>
              {routes}
            </Router>
          </ReduxProvider>
        </PersistGate>
      </ThemeProvider>
  );
}

export default App;
